/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'capitalize' })

export class CapitalizePipe implements PipeTransform {

    transform(value: any) {
        if (value) {
            value = value.toString();
            let strValue = value.split(" "), strFinal = '';
            for (let i = 0; i < strValue.length; i++) {
                if (strValue.length == (i+1)) {
                    strFinal += strValue[i].charAt(0).toUpperCase() + strValue[i].toLowerCase().slice(1);
                } else {
                    strFinal += strValue[i].charAt(0).toUpperCase() + strValue[i].toLowerCase().slice(1) + " ";
                }
            }
            return strFinal;
        }
        return value;
    }

}